var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('cs-preloader-overlay', {
    attrs: {
      "loading": _vm.loading
    }
  }, [_c('div', {
    staticClass: "overlay-container"
  }, [_c('div', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "header-container"
  }, [_vm.isDesktop ? _c('desktop-capusta-title', {
    attrs: {
      "title": _vm.$t('widget.ready.to.work'),
      "history-mode": _vm.widget.type !== 'DONATION_GOAL',
      "redirect": _vm.getRouteRedirectByType
    }
  }) : _c('mobile-capusta-title', {
    attrs: {
      "title": _vm.$t('widget.ready.to.work'),
      "history-mode": _vm.widget.type !== 'DONATION_GOAL',
      "redirect": _vm.getRouteRedirectByType
    }
  })], 1), _c('div', {
    staticClass: "form-container"
  }, [_c('div', {
    staticClass: "section-container"
  }, [_c('substrate-mount', [_c('div', {
    staticClass: "input-container"
  }, [_c('capusta-copy-field', {
    attrs: {
      "label": _vm.$t('link.to.obs.studio'),
      "value": _vm.widget.url
    }
  })], 1), _c('a', {
    staticClass: "information-link-container",
    attrs: {
      "href": "https://help.capusta.space/widget_integration",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('how.embed.in.stream')))]), _c('i')])])], 1), _c('div', {
    staticClass: "button-primary-container"
  }, [_c('cs-button', {
    attrs: {
      "width": _vm.buttonWidth
    },
    on: {
      "click": _vm.handleReady
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.run')) + " ")])], 1), _c('div', {
    staticClass: "button-primary-container"
  }, [_c('cs-button', {
    attrs: {
      "type": "secondary",
      "width": _vm.buttonWidth
    },
    on: {
      "click": _vm.sendTestEvent
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('streamer.widgets.button.event.test')) + " ")])], 1), _c('div', {
    staticClass: "button-secondary-container"
  }, [_c('cs-button', {
    attrs: {
      "type": "secondary",
      "width": _vm.buttonWidth
    },
    on: {
      "click": _vm.goToCabinet
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('to.main.page')) + " ")])], 1)])]), _c('iframe', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "streamsIframe",
      "src": _vm.widget.url
    }
  })])]);
}
var staticRenderFns = []

export { render, staticRenderFns }